import _0x26fa49 from'./loadImage.js';import _0x400be3 from'./preloadImages.js';export default{'loadImage':_0x26fa49,'preloadImages':_0x400be3};